<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-form @submit.prevent="submitForm">
        <b-col md="4">
          <b-row class="mb-4">
            <b-col>
              <b-button @click="agregarMaterial" variant="success">
                {{$t('agregar_material')}}
              </b-button>
            </b-col>
            <b-col>
              <b-button @click="quitarMaterial" variant="danger" :disabled="form.materiales.length === 1">
                {{$t('quitar_material')}}
              </b-button>
            </b-col>
          </b-row>

          <div v-for="(material, index) in form.materiales" :key="index" class="mt-2">
            <b-form-group :label="`${$t('material')} # ${index + 1}`" :label-for="'material-' + index">
              <b-form-input v-model="material.nombre" :id="'material-' + index" required
              :placeholder="$t('ingrese_nombre_material')"></b-form-input>
            </b-form-group>
            <b-form-group :label="`${$t('precio_material')} # ${index + 1}`" :label-for="'precio-' + index">
              <b-form-input v-model="material.precio" :id="'Precio-' + index" type="number" required
                placeholder="Ingrese el Precio"></b-form-input>
            </b-form-group>
            
            <b-form-group :label="`${$t('codigo')} # ${index + 1}`" :label-for="'codigo-' + index">
              <b-form-input v-model="material.codigo" :id="'codigo-' + index" type="number" required
                placeholder="Ingrese código"></b-form-input>
            </b-form-group>
          </div>
        </b-col>

        <b-button variant="danger" class="ml-2" @click="$router.push('/materiales')">
          <i class="fas fa-arrow-left"></i> {{$t('cancelar')}}
        </b-button>
        <b-button type="submit" v-if="form.materiales.length > 0" variant="primary">
          {{$t('guardar')}}
        </b-button>
      </b-form>
    </base-header>
  </div>
</template>

<script>
import materialService from '@/api/materialService';
export default {
  data() {
    return {
      form: {
        materiales: [],
      },
    };
  },
  async beforeMount() {
    this.form.materiales.push({
      nombre: '',
      precio: 0
    });
  },
  methods: {
    agregarMaterial() {
      this.form.materiales.push({
        nombre: '',
        precio: 0
      });
    },
    quitarMaterial() {
      if (this.form.materiales.length > 1) {
        this.form.materiales.pop();
      }
    },
    async submitForm() {
      try {
        const response = await materialService.create(this.form);
        if (!response) throw new Error('Ocurrio un error al crear el ingreso, intente nuevamente.');
        Swal.fire({
          title: "Creado correctamente",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          background: '#f8f9fa',
          customClass: {
            title: 'swal-title',
            icon: 'swal-icon',
          },
        });
        this.$router.push(`/materiales`);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message
        });
      }
    }
  }
};
</script>

<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
